import React from 'react';
import { formatDate } from '../../lib/formatters';

export const ORDER_COLUMNS = [
    {
        key: 'date',
        label: 'Aangemaakt',
        className: 'whitespace-nowrap',
        render: (order) => formatDate(order.date),
    },
    {
        key: 'order_id',
        label: 'Order ID',
        render: (order, { pageTranslations }) => (
            order.internal_id ? (
                <>
                    <a href={`/orders/${order.internal_id}/detail`} className="underline">{order.internal_id}</a>
                    {order.source !== 'webshop' && <>&nbsp;*</>}
                </>
            ) : (
                <em>{pageTranslations.externalIdUnknown}</em>
            )
        ),
    },
    {
        key: 'debtor',
        label: 'Debiteur',
        render: (order) => order.debtor_name,
    },
    {
        key: 'from',
        label: 'Van',
        render: (order) => order.pickup?.place,
    },
    {
        key: 'from_date',
        label: 'Ophaaldatum',
        className: 'whitespace-nowrap',
        render: (order, { translate }) => (order.pickup?.date ? formatDate(order.pickup.date) : translate('onbekend')),
    },
    {
        key: 'to',
        label: 'Naar',
        render: (order) => order.delivery?.place,
    },
    {
        key: 'to_date',
        label: 'Afleverdatum',
        className: 'whitespace-nowrap',
        render: (order, { translate }) => (order.delivery?.date ? formatDate(order.delivery.date) : translate('onbekend')),
    },
    {
        key: 'status',
        label: 'Status',
        render: (order, { translate }) => (
            <>
                {order.is_retour && (
                    <span className="text-red-600 mr-1">
                        <svg className="inline h-4 w-4 fill-current" role="img">
                            <use href="#glyph-retour"></use>
                        </svg>
                        {' '}{translate('Retour')}
                    </span>
                )}
                {order.internal_id ? (
                    <a href={`/orders/${order.internal_id}/detail#status-mutations`} className="underline">{order.status}</a>
                ) : (
                    order.status
                )}
            </>
        ),
    },
    {
        key: 'transport_type',
        label: 'Transporttype',
        render: (order) => order.transport_type,
    },
    {
        key: 'reference',
        label: 'Referentie',
        render: (order) => order.reference,
    },
    {
        key: 'order_reference',
        label: 'Klantreferentie',
        render: (order) => order.order_reference,
    },
];

export function resolveColumns(visibleColumns) {
    const resolved = (visibleColumns || [])
        .map((key) => ORDER_COLUMNS.find((column) => column.key === key))
        .filter(Boolean);

    return resolved.length > 0 ? resolved : ORDER_COLUMNS;
}
